import React from 'react';
import { NavLink } from 'react-router-dom';
import cn from 'classnames';

import Permitted from 'components/core/Permitted.component';
import PERM from 'constants/core/perm.const';
import LINK from 'constants/link.const';
import { useGilt, useTranslation } from 'providers/GILT.provider';
import { useCurrentSalonId } from 'providers/SalonBasicInfo.provider';
import { useTheme } from 'providers/Theme.provider';
import linkTo from 'utils/links/linkTo.util';

import CN from './TimeOffHeader.module.scss';

const MenuItem = ({ icon, children, disabled, isPlaceholder, to, ...extra }) => (
  <NavLink
    {...extra}
    to={isPlaceholder ? '#' : to}
    className={cn({
      [CN.menuItemDisabled]: disabled || isPlaceholder,
      [CN.menuItem]: !disabled && !isPlaceholder,
    })}
    activeClassName={isPlaceholder ? '' : CN.selected}
  >
    <div data-bem="MenuItem" className={CN.hoverContainer}>
      <div className={CN.menuText}>
        <div className={cn(CN[`${icon}Icon`])} />
        <div>{children}</div>
      </div>
    </div>
  </NavLink>
);

const TimeOffHeader = () => {
  const { isDarkMode } = useTheme();
  const salonId = useCurrentSalonId();
  const { isSalonInUS } = useGilt();
  const { t } = useTranslation();

  const summaryLink = linkTo({ pattern: LINK.slnStaffReportsKpi, params: { salonId }, fault: '#' });
  const tipsLink = linkTo({ pattern: LINK.slnStaffReportsTips, params: { salonId }, fault: '#' });
  const reportLink = linkTo({ pattern: LINK.slnStaffReportsTimeoff, params: { salonId }, fault: '#' });

  return (
    <div
      data-bem="TimeOffHeader"
      className={cn({
        [CN.component]: true,
        [CN.dark]: isDarkMode,
      })}
    >
      <div className={CN.container}>
        <Permitted value={PERM.canViewKpiReportsPersonal} tag="TimeOffHeader__kpi--personal">
          <MenuItem icon="kpi" to={summaryLink}>
            {t('staffKpisReports.kpiReportsTab')}
          </MenuItem>
        </Permitted>
        <Permitted value={PERM.canViewKpiReportsAllStaff} tag="TimeOffHeader__kpi--all">
          <MenuItem icon="kpi" to={summaryLink}>
            {t('staffKpisReports.kpiReportsTab')}
          </MenuItem>
        </Permitted>

        <MenuItem icon="time" to={reportLink}>
          {t('staffKpisReports.timeOffReportTab')}
        </MenuItem>
        {!isSalonInUS && (
          <MenuItem icon="coin" to={tipsLink}>
            {t('staffKpisReports.staffTippingTab')}
          </MenuItem>
        )}
      </div>
    </div>
  );
};

export default TimeOffHeader;
